import qs from 'qs';
import {
  Complex,
  ComplexDetails,
  OfferMapFilter,
  OfferMarker,
} from 'types/offer';
import { CommonResponse, get, post } from './clientAxios';

export async function getOfferMarkerInformation(mapData: OfferMapFilter) {
  try {
    const response = await get<CommonResponse<OfferMarker[]>>(
      `/api/complex/normal/mapList`,
      {
        params: mapData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        },
      },
    );

    const { data } = response.data;

    return { data, error: false };
  } catch (error) {
    console.log(error);
    return { error: true };
  }
}

export async function getComplexInformation(complexId: number) {
  try {
    const response = await get<CommonResponse<Complex>>(
      `/api/complex/complexInfo`,
      {
        params: { complexId },
      },
    );

    const { data } = response.data;

    return { data, error: false };
  } catch (error) {
    return { error: true };
  }
}

export async function getComplexList(bldNm: string) {
  try {
    const response = await post<CommonResponse<ComplexDetails[]>>(
      `/api/complex`,
      bldNm,
    );
    const { data } = response.data;
    return { data, error: false };
  } catch (error) {
    return { error: true };
  }
}
